// import config from 'config';
import { authHeader } from '../helpers';
import Userauth from '../auth/index';
import axios from 'axios'

export const userService = {
    login,
    // verify,
    refresh,
    logout,
    getAll
};

function login(email, password, remember) {

    return  axios.post('/shop/login', { email: email, password: password, remember: remember, })
        .then( response =>{

            const vendor = response.data

            // if (user.token) {
            //     // store user details and jwt token in local storage to keep user logged in between page refreshes
            //     localStorage.setItem('user', JSON.stringify(user));
                
            //     // set token in all request
            //     axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`
            // }
            if (vendor.token) {
                // set login
                Userauth.login(response.data, remember)
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                // localStorage.setItem('user', JSON.stringify(user));
                
                // set token in all request
                axios.defaults.headers.common['Authorization'] = `Bearer ${vendor.token}`
            }

            return vendor;

        })
}

// function verify(code, contact, remember, OTP, type) {

//     return  axios.post('/user/verify', { code: code, contact: contact, remember: remember, OTP: OTP, type: type })
//         .then( response =>{

//             const user = response.data

//             if (user.token) {
//                 // set login
//                 Userauth.login(response.data, remember)
//                 // store user details and jwt token in local storage to keep user logged in between page refreshes
//                 // localStorage.setItem('user', JSON.stringify(user));
                
//                 // set token in all request
//                 axios.defaults.headers.common['Authorization'] = `Bearer ${user.token}`
//             }

//             return user;

//         })
// }

function refresh(refresh_token) {
    
    return axios.post('/shop/refresh', { refresh_token: refresh_token })
    .then( response =>{

        const data = response.data

        if (data.token) {
            //
            Userauth.refreshToken(data)
            // store user details and jwt token in local storage to keep user logged in between page refreshes
        //    localStorage.setItem('user', JSON.stringify(user));
                
            // set token in all request
            axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`
        }

        return data;

    })
}

function logout() {

    // validate
    const User = JSON.parse(localStorage.getItem('user'))
    //
    if (!User) {
        //
        return true
    }

    const { refresh_token } = User

    return  axios.post('/shop/logout', { refresh_token: refresh_token } )
        .then( response =>{
            
            // remove user from local storage to log user out
            Userauth.logout()

            return response;

        }).catch(error =>{ 
            // remove user from local storage to log user out
            Userauth.logout()

            return error;
        })
    
}

function getAll() {

    //
    return axios.get('/shop/profile', { headers: authHeader() })
    .then( response =>{

        //
        Userauth.updateUser(response.data)

        return response.data
    })
}
